import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { slugify } from '../../../utils/slugify';
import { ServerVarsContext } from '../../../global/ServerVarsContext/ServerVarsContext';

// components
import { FormattedNumber } from 'react-intl';
import { AbsoluteAnchor } from '../../../global/AbsoluteAnchor/AbsoluteAnchor';

//styles
import styles from './SbSharedRefineMenuLink.scss';

export function SbSharedRefineMenuLink(props) {
    const {
        text,
        count,
        onClick,
        linkReference,
        linkable,
        className,
        shouldIndent,
        dataTn,
        selected,
        isHidden,
    } = props;
    const { isSbTopNavVariant } = useContext(ServerVarsContext);
    const refetchInFlight = useSelector(state => state.filters.refetchInFlight);

    const containerClass = classnames(styles.container, className, {
        [styles.selected]: selected,
        [styles.indent]: shouldIndent,
        'is-hidden': isHidden,
        [styles.disabled]: refetchInFlight,
    });

    return (
        <div
            onClick={onClick}
            className={containerClass}
            data-tn={`facet-link${selected ? '-selected' : ''}`}
        >
            <AbsoluteAnchor linkReference={linkReference} linkable={linkable}>
                <span className={styles.text} data-tn={`facet-content-${slugify(dataTn || text)}`}>
                    {text}
                </span>
            </AbsoluteAnchor>
            {!isSbTopNavVariant && !!count && (
                <span className={styles.count} data-tn={`facet-count-${slugify(dataTn || text)}`}>
                    <FormattedNumber value={count} />
                </span>
            )}
        </div>
    );
}

SbSharedRefineMenuLink.propTypes = {
    count: PropTypes.number,
    selected: PropTypes.bool,
    dataTn: PropTypes.string,
    linkable: PropTypes.bool,
    linkReference: PropTypes.string,
    className: PropTypes.string,
    shouldIndent: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    isHidden: PropTypes.bool,
};
